import React, { useContext, useState } from "react";
import classes from "./DeleteBoard.module.scss";
import Modal from "../Modal/Modal";
import { ModalContext } from "../../store/modal-context";
import { BoardContext } from "../../store/board-context";

const DeleteBoard = () => {
  const { modalPayload, closeModal } = useContext(ModalContext);
  const { boards, deleteBoard } = useContext(BoardContext);
  const { boardId } = modalPayload;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const board = boards.find((b) => b.id === boardId);

  if (!board) return null;

  const handleDelete = async () => {
    setIsSubmitting(true);
    await deleteBoard(boardId);
    setIsSubmitting(false);
    closeModal();
  };

  return (
    <Modal>
      <section
        className={`${classes.delete_board}`}
      >
        <h3>delete this board?</h3>
        <p>
          Are you sure you want to delete the '{board.title}' board? This
          action will remove all columns and tasks and cannot be reversed.
        </p>
        <section className={classes.delete_action}>
          <button className={classes.delete} onClick={handleDelete} disabled={isSubmitting}>
            {isSubmitting ? "deleting…" : "delete"}
          </button>
          <button
            className={`${classes.cancel}`}
            onClick={closeModal}
            disabled={isSubmitting}
          >
            cancel
          </button>
        </section>
      </section>
    </Modal>
  );
};

export default DeleteBoard;
